import React from "react";
import LeftArrow from "assets/icons/left.svg";
import RightArrow from "assets/icons/right.svg";

import "./pagination.scss";

const Pagination = (props) => {
  const { pages, current, onClick } = props;

  const onPrev = () => onClick && onClick(current - 1);
  const onNext = () => onClick && onClick(current + 1);
  const onPrevDash = () => onClick && onClick(current - 2);
  const onNextDash = () => onClick && onClick(current + 2);

  const getPageNumbers = () => {
    const pageNumbers = [];
    const lastThreeStart = pages - 2;
    
    pageNumbers.push(1);
    
    const middleStart = Math.max(2, current - 1);
    const middleEnd = Math.min(pages - 3, current + 1);
    
    if (middleStart > 2) {
      pageNumbers.push('left-ellipsis');
    }
    
    for (let i = middleStart; i <= middleEnd; i++) {
      if (i > 1 && i < lastThreeStart) {
        pageNumbers.push(i);
      }
    }
    
    if (middleEnd < lastThreeStart - 1) {
      pageNumbers.push('right-ellipsis');
    }
    
    for (let i = lastThreeStart; i <= pages; i++) {
      if (i > 1 && !pageNumbers.includes(i)) {
        pageNumbers.push(i);
      }
    }
    
    return pageNumbers;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div>
      <div className="pagination">
        <div className="pagination-wrapper">
          {current !== 1 && (
            <div onClick={onPrev} className={"left-arrow"}>
              <img src={LeftArrow} alt="LeftArrow" />
            </div>
          )}

          {pageNumbers.map((page, index) => {
            if (page === 'left-ellipsis') {
              return (
                <span key="left-ellipsis" className="ellipsis">
                  ...
                </span>
              );
            }
            if (page === 'right-ellipsis') {
              return (
                <span key="right-ellipsis" className="ellipsis">
                  ...
                </span>
              );
            }
            return (
              <button
                key={page}
                onClick={() => onClick && onClick(page)}
                className={page === current ? "page-counter active-page" : ""}
              >
                {page}
              </button>
            );
          })}

          {current !== pages && (
            <div onClick={onNext} className={"right-arrow"}>
              <img src={RightArrow} alt="RightArrow" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default Pagination;
